import { render, staticRenderFns } from "./ContractInfoPage.vue?vue&type=template&id=fd70a01a&"
import script from "./ContractInfoPage.vue?vue&type=script&lang=js&"
export * from "./ContractInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports